var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "performer-tile-container" },
    [
      _c(
        "router-link",
        {
          staticClass: "performer",
          attrs: {
            to: "performers/" + _vm.artistId,
            title: "" + _vm.artistName
          }
        },
        [
          _c("div", { staticClass: "performer-image-container" }, [
            _c("div", {
              staticClass: "performer-image",
              style: {
                backgroundImage:
                  "url(" +
                  (_vm.$store.state.isMobile
                    ? _vm.images.rectangle
                    : _vm.images.square) +
                  ")"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "info-section" }, [
              _c("div", [
                _c("div", { staticClass: "info-section__performer" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.truncatedArtistName) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section__number_events" }, [
                  _vm._v(_vm._s(_vm.eventCount) + " events")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", {
                  staticClass: "info-section__chevron icon-chevron-lg-right"
                })
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }